/**
 * @generated SignedSource<<6c37b47cbed49cd9829f0c8d4e35eae3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UserType = "ADMIN" | "BOT" | "GUEST" | "MEMBER";
export type AssignableDropdownAssigneeSelectQuery$variables = {
  noteId: string;
};
export type AssignableDropdownAssigneeSelectQuery$data = {
  readonly node: {
    readonly noteuserSet?: ReadonlyArray<{
      readonly id: string;
      readonly user: {
        readonly email: string;
        readonly firstName: string;
        readonly fullName: string;
        readonly id: string;
        readonly image: string;
        readonly isExternal: boolean;
        readonly isGuest: boolean;
        readonly type: UserType;
      };
    }>;
  } | null;
};
export type AssignableDropdownAssigneeSelectQuery = {
  response: AssignableDropdownAssigneeSelectQuery$data;
  variables: AssignableDropdownAssigneeSelectQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "noteId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "noteId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteUser",
      "kind": "LinkedField",
      "name": "noteuserSet",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fullName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "image",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isGuest",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isExternal",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AssignableDropdownAssigneeSelectQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AssignableDropdownAssigneeSelectQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v3/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "61f8a00ce3e9260c362e1c95e9df8c7e",
    "id": null,
    "metadata": {},
    "name": "AssignableDropdownAssigneeSelectQuery",
    "operationKind": "query",
    "text": "query AssignableDropdownAssigneeSelectQuery(\n  $noteId: ID!\n) {\n  node(id: $noteId) {\n    __typename\n    ... on Note {\n      noteuserSet {\n        id\n        user {\n          id\n          type\n          firstName\n          fullName\n          email\n          image\n          isGuest\n          isExternal\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f683606c0215537aaf64756f27a4fe84";

export default node;
